import { Component, DestroyRef, EventEmitter, Input, Output, effect, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppSettings } from '@services/settings/app-settings.service';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { UserService } from '@services/core/user.service';
import { EntityService } from '@services/core/sharing.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
declare var slideToggle: any;

@Component({
	selector: 'header',
	templateUrl: './header.component.html',
	styleUrls: ["./header.component.css"],
	providers: [EntityService],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: true,
})
export class HeaderComponent implements OnInit{
	@Output() appSidebarMobileToggled = new EventEmitter<boolean>();

	protected logo = ""
	protected profilePhotoURL
	protected userData
	public entities = []
	public entitiesTemp = []
	public appSettings = inject(AppSettings)
	private userService = inject(UserService)
	private authMicrosoft = inject(MicrosoftAuthService)
  private entityService = inject(EntityService)
  private destroyRef = inject(DestroyRef)

	toggleAppSidebarMobile() {
		this.appSidebarMobileToggled.emit(true);
	}

	constructor(){
		effect(()=> {
			this.userData = this.userService.userData()
			this.profilePhotoURL = this.userService.userPhoto()
			
		})
		effect(() => {
			this.entities = this.userService.sharingEntities()
			this.entitiesTemp = this.entities
		})
	}

	ngOnInit(): void {
		
	}
	
	logout() {
		this.authMicrosoft.clearSesion()
		this.authMicrosoft.logout().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
			let a = document.createElement('a')
			a.href = res.url
			a.click()
		})
	}

	cambiaentidad(entity){
		this.userService.sharingEntity.set(entity)
		this.entityService.setEntity(entity).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {

		})
	}

	filtrarEntidades(event){
		const find = event.toLowerCase()
		this.entities = this.entitiesTemp.filter(entity => 
			entity.name.toLowerCase().includes(find)	|| 
			entity.code.toString().includes(find) || 
			entity.group.toLowerCase().includes(find) || 
			entity.campus.toLowerCase().includes(find)
		)
	}
}
